import { Loader } from '@/modules/ui';

// TODO: show it after 200ms to prevent flickering
export const AuthLoader = () => {
    return <Loader randomize minHeight='100dvh' />;
};
